<template>
  <div class="step-artigo">
    <div class="form-group">
      <label class="field-label">Título</label>
      <input
        class="form-control form-control-sm"
        v-model="item.titulo"
        placeholder="Pergunta ou assunto do artigo"
      />
      <div v-if="validacao.firstError('item.titulo')" class="message">
        {{ validacao.firstError("item.titulo") }}
      </div>
    </div>

    <div class="step-artigo__section">
      <div class="section-label">Tipo de conteúdo</div>
      <div class="step-artigo__tipos-grid">
        <SelectableCard
          v-for="tipo in tipos"
          :key="tipo.tipo"
          :value="tipo.tipo"
          :label="tipo.label"
          :description="descricaoTipo(tipo.tipo)"
          :icon="iconeTipo(tipo.icone)"
          :selected="item.tipo === tipo.tipo"
          @select="selecionarTipo"
        />
      </div>
      <p class="step-artigo__hint">
        O tipo define a categoria pela qual o artigo é filtrado e o ícone com que
        ele aparece nas centrais de ajuda. Não limita o conteúdo.
      </p>
      <div v-if="validacao.firstError('item.tipo')" class="message">
        {{ validacao.firstError("item.tipo") }}
      </div>
    </div>

    <div class="step-artigo__section">
      <div class="section-label">Palavras-chave</div>
      <VueTagsInput
        style="max-width: none; width: 100%"
        v-model="tag"
        :tags="item.palavras_chave"
        @tags-changed="atualizarTags"
        :allow-edit-tags="true"
        placeholder="Digite e pressione Enter"
        :validation="validacaoTag"
        class="my-custom-wrapper"
      />
      <p class="step-artigo__hint">
        A busca do FAQ dá o maior peso às palavras-chave: use os termos que o
        usuário digitaria.
      </p>
      <div v-if="validacao.firstError('item.palavras_chave')" class="message">
        {{ validacao.firstError("item.palavras_chave") }}
      </div>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import { iconeTipo, descricaoTipo } from "../helpers/faqLabels";

export default {
  name: "StepArtigo",
  components: { VueTagsInput, SelectableCard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    tipos: {
      type: Array,
      default: () => [],
    },
    validacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tag: "",
      validacaoTag: [
        {
          classes: "min-length",
          rule: (tag) => tag.text.length < 3,
          disableAdd: true,
        },
      ],
    };
  },
  methods: {
    iconeTipo,
    descricaoTipo,
    selecionarTipo(tipo) {
      this.$set(this.item, "tipo", tipo);
    },
    atualizarTags(novasTags) {
      this.$set(this.item, "palavras_chave", novasTags);
    },
  },
};
</script>

<style scoped>
.step-artigo .form-group {
  margin-bottom: 10px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.message {
  font-size: 11px;
  color: #d92d20;
  margin-top: 2px;
}

.step-artigo__section {
  margin-top: 12px;
  margin-bottom: 12px;
}

.section-label {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  color: #344054;
  letter-spacing: 0.3px;
  background: #f2f4f7;
  border-left: 3px solid #3a3e81;
  padding: 6px 10px;
  margin-bottom: 8px;
}

.step-artigo__tipos-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.step-artigo__hint {
  font-size: 11px;
  color: #98a2b3;
  margin: 6px 0 0;
}

@media (max-width: 768px) {
  .step-artigo__tipos-grid {
    grid-template-columns: 1fr;
  }
}
</style>
